/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PncFullLotNumberChipComponent} from './pnc-full-lot-number-chip.component';
import {TooltipModule} from '../../../../../shared/tooltip/tooltip.module';

@NgModule({
    declarations: [PncFullLotNumberChipComponent],
    imports: [
        CommonModule,
        TooltipModule
    ],
    exports: [PncFullLotNumberChipComponent]
})
export class PncFullLotNumberChipModule {
}
